'use client'
import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { useRouter } from 'next/router';
import useAuth from "../hooks/useAuth"

// import { get_access_token } from '../../utils/supabase-auth';


interface AuthContextType {
  login: (email: string, password: string) => Promise<any>;
  register: (email: string, password: string, redirectTo: string) => Promise<any>;
  verify_email: (email: string, code: string, type: string, authType: string) => Promise<any>;
  reset_password: (email: string, redirectTo: string) => Promise<any>;
  update_password: (password: string) => Promise<any>;
}

const defaultState = {
    login: null,
    register: null,
    verify_email: null,
    reset_password: null,
    update_password: null,
}

const ignorePaths = ['/','/verify-email', '/register', '/login','/forgot-password','/index','/hapeornot','/reset-password','/vote','/auth/callback']




const AuthContext = createContext<AuthContextType>(defaultState)

function AuthProvider({ children }) {
	const router = useRouter()
	const pathname = router.pathname
	const { get_access_token } = useAuth()
	const [isChecking, setIsChecking] = useState(true)

	// 返回是否通过鉴权
	const checkAuth = async (): Promise<boolean> => {
		// 白名单页面直接放行
		if (ignorePaths.includes(pathname)) {
			return true
		}

		const access_token = await get_access_token()
		// console.log("AuthProvider checkAuth access_token", access_token)

		if (!access_token) {
			console.log("用户未登录，跳转到登录页面")
			console.log("pathname", pathname, ignorePaths.includes(pathname), ignorePaths)
			if (!ignorePaths.includes(pathname)) {
				// 未登录，直接跳转到 login，但本页面保持 isChecking=true，不渲染 children
				router.replace("/login")
				return false
			}
		}

		return true
	}

	// 每次路由变化时，优先检查是否已登录
	useEffect(() => {
		let cancelled = false

		const run = async () => {
			// 白名单页面不做登录拦截，直接渲染
			if (ignorePaths.includes(pathname)) {
				setIsChecking(false)
				return
			}

			setIsChecking(true)
			const ok = await checkAuth()

			// 只有鉴权通过时，才在当前路径下关闭 loading，渲染 children
			if (!cancelled && ok) {
				setIsChecking(false)
			}
		}

		run()

		return () => {
			cancelled = true
		}
	}, [pathname])

	return (
		<AuthContext.Provider value={useAuth()}>
			{/* 需要认证的页面，在完成 checkAuth 前先不渲染 children，避免未登录时页面逻辑先执行 */}
			{isChecking && !ignorePaths.includes(pathname) ? null : children}
		</AuthContext.Provider>
	)
}

export { AuthContext, AuthProvider }
